module.exports = __webpack_public_path__ + "static/img/h-head.611d8780.webp";